import { ButtonBase } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router'
import IcBaselineHome from '~icons/ic/baseline-home'
import IcBaselineIosShare from '~icons/ic/baseline-ios-share'
import UserLink from 'src/components/UserWidget/UserLink'
import type { Manga } from 'src/services/apollo/generated/graphql'
import { MangaType } from 'src/services/apollo/generated/graphql'
import MangaLikeButton from '../Common/MangaLikeButton'
import MangaExtraActions from './Action'
import { useDialogMangaShare } from './Share'

const MangaViewerNavbar: FC<{
  manga: Manga
  showHomeButton?: boolean
  onLikeClick?: () => void
}> = ({ manga, showHomeButton = true, onLikeClick }) => {
  const dialogMangaShare = useDialogMangaShare()

  return (
    <div className="h-[48px] flex items-center gap-4 px-4">
      {showHomeButton && (
        <ButtonBase component={Link} to="/">
          <IcBaselineHome className="size-6" />
        </ButtonBase>
      )}
      <div className="flex-1" />
      <UserLink
        user={manga.author ?? manga.artwork?.author}
        showName={false}
        target="_blank"
        scene="mange"
      />
      <MangaExtraActions manga={manga} />
      {manga.type === MangaType.Comic && (
        <MangaLikeButton manga={manga} afterClick={onLikeClick} />
      )}
      <ButtonBase
        onClick={() => {
          dialogMangaShare(manga)
        }}
      >
        <IcBaselineIosShare className="size-6" />
      </ButtonBase>
    </div>
  )
}

export default MangaViewerNavbar
